import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 5h-6a2 2 0 0 0 -2 2v12","key":"svg-0"}],["path",{"d":"M7 15h4","key":"svg-1"}],["path",{"d":"M9 11h7","key":"svg-2"}]]

/**
 * IconCurrencyFrank
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktZnJhbmsiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE3IDVoLTZhMiAyIDAgMCAwIC0yIDJ2MTIiIC8+CiAgPHBhdGggZD0iTTcgMTVoNCIgLz4KICA8cGF0aCBkPSJNOSAxMWg3IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/currency-frank
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyFrank = createReactComponent('outline', 'currency-frank', 'CurrencyFrank', __iconNode);

export default IconCurrencyFrank;